import { Routes, Route } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/menu/dashboard";
import Others from "./scenes/menu/others";
import { ColorModeContext, useMode } from "./contexts/theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Box } from "@mui/material";
import ViewerComponent from "./forge/ViewerComponent";
import { useState } from "react";

import AirQuality from "./scenes/menu/air_quality";
import SolarEnergy from "./scenes/menu/solar_energy";
import WaterDection from "./scenes/menu/water_detection";
import TiltDetection from "./scenes/menu/tilt_detection";
import Temperature from "./scenes/menu/temperature";
import Vibration from "./scenes/menu/vibration";
import Window from "./scenes/menu/window";

function App() {
  const [theme, colorMode] = useMode();
  const [viewController, setViewController] = useState(undefined);
  const [urn, setUrn] = useState(null);

  const isolateComponents = (component_array) => {
    if (viewController !== undefined) {
      viewController.isolate(component_array);
      viewController.select(component_array);
    } else {
      console.log("viewer is undefined");
    }
  };

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          {/* 서비스의 사이드바 */}
          <div className="SideBar"> 
            <Sidebar isolation={isolateComponents}/>
          </div>
          {/* 오른쪽 부분 */}
          <div className="RightBar">
            <div className="content">
              {/* 헤더 */}
              <Topbar />

              {/* FORGE 모델 */}
              <Box>
                <ViewerComponent className="main-3D" setViewController={setViewController} setUrn={setUrn} />
              </Box>
              
              <Box m="20px">

                {/* 데이터 시각화 */}
                <Box className="main-graph">
                  <Routes>
                    <Route path="/" element={<Dashboard viewer={viewController} urn={urn} />} />
                    <Route path="/airquality" element={<AirQuality urn={urn}/>} />
                    <Route path="/solarenergy" element={<SolarEnergy />} />
                    <Route path="/waterdetection" element={<WaterDection />} />
                    <Route path="/tiltdetection" element={<TiltDetection />} />
                    <Route path="/temperature" element={<Temperature />} />
                    <Route path="/vibration" element={<Vibration />} />
                    <Route path="/window" element={<Window />} />
                    <Route path="/others" element={<Others />} />
                  </Routes>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
